import { Select, Tooltip } from "antd";
import type {
  RoleOptionContentProps,
  RoleSelectedLabelProps,
  RoleSelectOption,
  RoleSelectProps,
} from "./roleSelect.types";

function resolveTitle(option: RoleSelectOption) {
  if (option.title) {
    return option.title;
  }
  return typeof option.label === "string" ? option.label : undefined;
}

function RoleOptionContent({ option }: RoleOptionContentProps) {
  return (
    <Tooltip title={option.title} placement="topLeft" mouseEnterDelay={0.3}>
      <div className="line-clamp-2 whitespace-normal break-words leading-snug">
        {option.label}
      </div>
    </Tooltip>
  );
}

function RoleSelectedLabel({ label, title }: RoleSelectedLabelProps) {
  return (
    <Tooltip title={title} placement="topLeft">
      <span className="block truncate">{label}</span>
    </Tooltip>
  );
}

export default function RoleSelect({ options, ...rest }: RoleSelectProps) {
  const optionsWithTitles = options.map((option) => ({
    ...option,
    title: resolveTitle(option),
  }));
  const titleByValue = new Map(
    optionsWithTitles.map((option) => [option.value, option.title]),
  );

  return (
    <Select<string>
      {...rest}
      options={optionsWithTitles}
      popupMatchSelectWidth={false}
      styles={{
        popup: {
          root: { minWidth: 280, maxWidth: "min(420px, calc(100vw - 32px))" },
        },
      }}
      optionRender={(option) => (
        <RoleOptionContent option={option.data as RoleSelectOption} />
      )}
      labelRender={({ label, value }) => (
        <RoleSelectedLabel
          label={label}
          title={titleByValue.get(String(value))}
        />
      )}
    />
  );
}
